// export type TApiConfiguration = {
//     // accessToken?: string;
//     urlApiBase: string;
//     // csrfToken?: string;
//     // feow: string;
// }

// console.log('demo7',location.pathname.split('/',2)[1]);
const home = document.querySelector('body').dataset.home;
if (!home) {
    console.error('ATTRIBUTO HOME NON PRESENTE O NON VALIDO');
}

export const apiConfigurationDefault = {
    // accessToken: getCookie('fec'),
    urlApiBase: location.origin + home,
    // feow: 'reauth_1'
    //csrfToken: document.querySelector('[name=csrf-token]').getAttribute('content')
}   